function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.5 0L11.6329 6.56434H18.535L12.9511 10.6213L15.084 17.1857L9.5 13.1287L3.91604 17.1857L6.04892 10.6213L0.464963 6.56434H7.36712L9.5 0Z",
  fill: "#888888"
});

const SvgComponent = props => React.createElement("svg", _extends({
  width: 19,
  height: 18,
  viewBox: "0 0 19 18",
  fill: "none"
}, props), _ref);

export default __webpack_public_path__ + "static/media/star.a17976d6.svg";
export { SvgComponent as ReactComponent };